import { createContext } from 'react';
import { Feedback, Steps } from "./types";

const defaultReasonStep = {
  title: '',
  subtitle: '',
  placeholder: '',
  submitButton: '' };


const defaultContext = {
  feedback: Feedback.Awesome,
  reason: '',
  copyConfig: {
    steps: {
      [Steps.Emoji]: {
        title: '',
        subtitle: '',
        firstLabel: '',
        lastLabel: '' },

      [Steps.Reason]: {
        [Feedback.Horrible]: defaultReasonStep,
        [Feedback.Bad]: defaultReasonStep,
        [Feedback.Okay]: defaultReasonStep,
        [Feedback.Great]: defaultReasonStep,
        [Feedback.Awesome]: defaultReasonStep },

      [Steps.Conclusion]: {
        title: '',
        subtitle: '' } },


    undoButtonText: '',
    dismissedText: '' },

  reasonRequired: false,
  setReason: () => void 0,
  handleFeedback: () => void 0,
  handleDismiss: () => void 0,
  handleSubmit: () => void 0 };


const FeedbackCardContext = /*#__PURE__*/createContext(defaultContext);

export default FeedbackCardContext;